import React, { useRef, useEffect } from "react";
import "./Program.css";
import ImageProgram from "../../assets/image/img-program.png";
import DataHelper, {dataFoto, dataProgram} from "../../dataHelper/DataHelper";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link  } from "react-router-dom";


const Program = (props) => {
   useEffect(() => {
     AOS.init({
       duration: 1000, // Durasi animasi dalam milidetik
       easing: "ease", // Efek ease untuk animasi yang lebih halus
     });
   }, []);

const sliderRef = useRef(null);

  const settings = {
    dots: true,
    autoplay: true,
    infinite: true,
    slidesToShow: 4,
    autoplaySpeed: 5000,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };


  // const prevSlide = () => {
  //   sliderRef.current.slickPrev();
  // };

  // const nextSlide = () => {
  //   sliderRef.current.slickNext();
  // };

  return (
    <>
      <div className='container-program'>
        <p className='title-program' data-aos='fade-up'>
          Program Kami ???
        </p>
        <p className='article-program' data-aos='fade-up' data-aos-delay='500'>
          Transformasi berkelanjutan melalui solusi inovatif demi harmoni
          lingkungan dan kemakmuran."
        </p>
      </div>

      <Slider {...settings} ref={sliderRef}>
        {DataHelper && dataProgram.map((card, index) => (
          <Link to={card.link} key={index} className='yuhu'>
            <div className='body-card border-2 border-yellow-600 '>
              <img className='img-tail' src={card.img} alt='' />
              <div className='card-footer border-2 border-t-yellow-600 border-s-transparent border-b-transparent border-e-transparent'>
                <div className='title-footer-card'>
                  <h1 className='pl-6 text-xl underline md:underline-offset-4'>
                    {card.title}{" "}
                  </h1>
                  <p className=' px-6'>{card.description}</p>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </Slider>

      {/* <div className='carousel-controls'>
        <button onClick={prevSlide} className='btn-slider'>
          Prev
        </button>
        <button onClick={nextSlide} className='btn-slider'>
          Next
        </button>
      </div> */}
    </>
  );
};

export default Program;
